
import Vue from 'vue'
import XmDialog from './XmDialog'
XmDialog.install = function (ensureHanlder,options,cancelHandler) {
  if (!ensureHanlder) {
    ensureHanlder = function () {}
  }
  if (!cancelHandler) {
    cancelHandler = function () {}
  }
  // 定义data 
  if (!options) {
    options = {}
  }
  options['message'] = options.message ? options.message : '确认删除此数据？' // 一级标题
  options['title'] = options.title ? options.title : '提示' // 弹窗顶部信息
  options['subMessage'] = options.subMessage ? options.subMessage : '删除后不可恢复，请谨慎操作！' // 提示内容
  options['isCloseIcon'] = options.isCloseIcon || true // 弹窗顶部关闭按钮是否展示
  options['ensureBtnText'] = options.ensureBtnText ? options.ensureBtnText : '确认' // 自定义确认按钮文字
  const MyHlAlert = Vue.extend(XmDialog)
  // 创建一个vue的实例
  const currentComponent = new MyHlAlert({
    data: options,
    methods: {
      ensureHanlder, // 确认按钮回调
      cancelHandler // 取消按钮回调
    }
  }).$mount()
  document.querySelector('body').appendChild(currentComponent.$el)
}

export default XmDialog



// WEBPACK FOOTER //
// ./src/components/xmDialog/index.js